import { createPortal } from 'react-dom';
import { Box, Button, Icon, Modal, Text } from '@quintoandar-tokko/jopijs';
import styles from './header.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../Dashboard.trans.json';

function ConfirmationModal({ handleClose, handleCancel, handleConfirm }) {
  return createPortal(
    <Modal
      modalBG
      blockScroll
      variant="center"
      className={styles.confirmModal}
      closeModal={handleClose}
    >
      <Box className={styles.confirmModalHeader}>
        <Text className={styles.confirmModalTitle}>
          {Trans(translations, 'YouAreExitingEditingMode')}
        </Text>
        <Icon
          onClick={handleClose}
          icon="icon-cerrar"
          fontSize="16px"
          role="button"
          aria-label="close"
          className={styles.confirmModalCloseIcon}
        />
      </Box>
      <Modal.Body
        variant={['center', 'sm']}
        className={styles.confirmModalBody}
      >
        <Text className={styles.confirmModalText}>
          {Trans(translations, 'DoYouWantToSaveYourChanges')}
        </Text>
      </Modal.Body>
      <Modal.Footer variant="center" className={styles.confirmModalFooter}>
        <Button variant={['subtleText', 'medium']} onClick={handleCancel}>
          {Trans(translations, 'ExitWithoutSaving')}
        </Button>
        <Button variant={['primary', 'medium']} onClick={handleConfirm}>
          {Trans(translations, 'Save')}
        </Button>
      </Modal.Footer>
    </Modal>,
    document.body
  );
}

export default ConfirmationModal;
